import QRCode from "qrcode";
import { useEffect, useRef, useState } from "react";
import { useCompanyProfile } from "../../../context/CompanyProfile"; // adjust as needed
import ExpiredCouponPreview from "./ExpiredCouponPreview";

function CouponRedemptionMock({ previewData }) {
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const couponRef = useRef(null);
  const { profile } = useCompanyProfile();

  useEffect(() => {
    if (previewData?.unique_code) {
      QRCode.toDataURL(previewData.unique_code).then(setQrCodeUrl);
    }
  }, [previewData]);

  let discountDisplay = "Unknown OFF";
  if (previewData.discount_type === "percentage") {
    discountDisplay = `${previewData.discount_value}% OFF`;
  } else if (previewData.discount_type === "fixed") {
    discountDisplay = `$${previewData.discount_value} OFF`;
  }

  const today = new Date();
  const isExpired =
    previewData?.endDate && new Date(previewData.endDate) < today;

  if (isExpired) {
    return <ExpiredCouponPreview previewData={previewData} />;
  }

  return (
    <div
      className="relative p-8 rounded-3xl shadow-2xl text-center max-w-md w-full"
      style={{
        backgroundColor: previewData.background_color || "#ffffff",
        color: previewData.text_color || "#000000",
      }}
    >
<div className="absolute top-2 left-2 bg-white/80 text-gray-800 text-xs px-2 py-1 rounded-full shadow backdrop-blur-sm">
  🔍 Preview Only
</div>

       {/* Logo */}
       {previewData.show_logo && previewData.company_logo && (
          <div className="flex justify-center mb-4">
            <div
              className="w-48 h-48 rounded-full overflow-hidden border-4"
              style={{
                borderColor: previewData.discount_color || "#9333ea",
              }}
            >
              <img
                src={previewData.company_logo}
                alt="Company Logo"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        )}
      {/* Title */}
      <h2
        className={`${
          previewData.title_size || "text-3xl"
        } font-extrabold mb-2`}
        style={{ color: previewData.title_color || "#000000" }}
      >
        {previewData.thank_you_title}
      </h2>

      {/* Subtitle */}
      <p
        className={`${previewData.subtitle_size || "text-sm"} mb-6`}
        style={{ color: previewData.subtitle_color || "#6b7280" }}
      >
        {previewData.thank_you_subtitle}
      </p>
     
      {/* Discount */}
      <p
        className={`${previewData.discount_size || "text-5xl"} font-black mb-2`}
        style={{ color: previewData.discount_color || "#9333ea" }}
      >
        {discountDisplay}
      </p>

      {/* Order note */}
      {/* Order note */}
      {previewData.note && (
        <p
          className={`${previewData.note_size || "text-sm"} mb-6`}
          style={{ color: previewData.note_color || "#6b7280" }}
        >
          {previewData.note}
        </p>
      )}

      {/* QR Code */}
      {qrCodeUrl && previewData?.show_qr_code && (
        <div className="flex justify-center my-4">
          <img src={qrCodeUrl} alt="QR Code" className="w-28 h-28" />
        </div>
      )}

      {/* Coupon Code Button */}
      <button
        className="w-full py-3 font-bold rounded-full mb-2 transition-all"
        style={{
          backgroundColor: previewData.code_bg_color || "#ffffff",
          color: previewData.code_text_color || "#7c3aed",
          border:
            previewData.code_border_style === "none"
              ? "none"
              : `2px ${previewData.code_border_style || "dashed"} ${
                  previewData.code_border_color || "#7c3aed"
                }`,
        }}
      >
        {previewData.unique_code}
      </button>

      {/* Tap to copy */}
      <p className="text-xs text-purple-500 mt-1">Tap to copy code</p>

      {/* Valid / Used Status */}
      {previewData.is_used ? (
        <p className="text-xs text-red-500 mt-2">⚠️ Coupon already used</p>
      ) : (
        <p className="text-xs text-green-500 mt-2">✅ Coupon is valid</p>
      )}

      {/* Validity */}
      {previewData?.endDate && (
        <p
          className={`${previewData.validity_size || "text-xs"} mt-8`}
          style={{ color: previewData.validity_color || "#9ca3af" }}
        >
          Offer valid until{" "}
          {new Date(previewData.endDate).toLocaleDateString(undefined, {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>
      )}
    </div>
  );
}

export default CouponRedemptionMock;
